module.exports = __webpack_public_path__ + "f9de084eab50d114a28b02b61574b40d.svg";